import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';
import { ICertificateTask } from '../../../../../../../../shared/interfaces/ICertificateTask';

type AddAccessButtonProps = {
  certificateTask: ICertificateTask;
};

const AddAccessButton = ({ certificateTask }: AddAccessButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const { openDialog } = useDialogContext();

  const onClick = (): void => {
    openDialog('answer-certificate-task-dialog', { certificateTask });
  };

  return (
    <Button onClick={onClick} label={t('tasksPage.tabs.certificateTasksTab.buttons.addAccess')} />
  );
};

export default AddAccessButton;
